import React, { useState} from 'react'
import {Button, Input, Row, message, Col} from "antd";
import './Gift.css'
import {getBillingApi} from "../../api";


export default function NewDiscount(props) {
    const {fetchDiscounts} = props
    const [giftCode, setGiftCode] = useState(undefined)


    const submitCode = (giftCode) => {
        getBillingApi().activateDiscountCode({discountCode: giftCode})
            .then((result) => {
                message.success("کد تخفیف با موفقیت فعال شد.", 5);
                setGiftCode("");
                fetchDiscounts();
            })
            .catch((error) => {
                message.error("کد تخفیف فعال نشد!!!", 5);
            });
    }


    return <React.Fragment>
        <div className='gift-code-container  px-40'>
            <div className=''>
                <Row className=''>
                    <Col span={24} className=''>
                        <label className='f-22'>ورود کد هدیه یا تخفیف</label>
                    </Col>
                </Row>
                <Row className=''>
                    <Input
                        className='input-gift'
                        value={giftCode}
                        onChange={event => setGiftCode(event.target.value)}/>
                </Row>

                <Row justify="center">
                    <Button
                        block
                        className='my-32'
                        type="primary"
                        onClick={event => giftCode && submitCode(giftCode)}
                    >ثبت کد</Button>
                </Row>
            </div>
        </div>
    </React.Fragment>

}
